import React, { useState, useEffect } from 'react'
import Radio from '../Radio/Radio.jsx'
import Checkbox from '@material/react-checkbox'
import { isEqual } from 'lodash'

const ClubOffers = ({ filtersId, updateList, updateSelection, filters }) => {

  const defaultState = {
    'Breakfast': {},
    'Lunch': {},
    'Afternoon Tea': {},
    'Dinner': {},
  }
  const [ activeFilters, setActiveFilters ] = useState(defaultState)
  const [ anyMeal, setAnyMeal ] = useState(false)
  const [ clubOffersOnly, setClubOffersOnly ] = useState(filters ? filters.clubOffersOnly : false)

  useEffect(() => {
    setClubOffersOnlyFilter()
  }, [clubOffersOnly])

  useEffect(() => {
    if ( !isEqual(filters.list, activeFilters) ) {
      setActiveFilters(filters.list)
    }
    if ( filters.clubOffersOnly !== clubOffersOnly ) {
      setClubOffersOnly(filters.clubOffersOnly)
    }
  })

  const setClubOffersOnlyFilter = () => {
    updateSelection(
      {
        'field': 'limited_edition_bool',
        'condition': 'eq',
        'value': 1,
      },
      clubOffersOnly ? 'add' : 'remove'
    )
    updateList(null, null, {
      clubOffersOnly,
    })
  }


  const setFilters = (mealName, day, add = true) => {
    let newFilters = {...activeFilters}
    const filters = {
      filters: [
        {
          'field': 'membership_validities.meal.name',
          'condition': 'eq',
          'value': mealName,
        },
        {
          'field': 'membership_validities.day_of_week',
          'condition': 'eq',
          'value': day,
        }
      ]
    }
    updateSelection(
      filters,
      add ? 'add' : 'remove'
    )

    newFilters[mealName][day] = add ? true : false

    setActiveFilters(newFilters)
  }

  const getRadios = (mealName) => {
    const radios = []
  
    for ( let x = 0; x < 7; x++ ) {
      let isChecked = false;
      if ( activeFilters[mealName] && activeFilters[mealName][x] ) {
        isChecked = true
      }
      if ( anyMeal ) {
        isChecked = false
      }
      radios.push(
        <span className="c-searchRadio">
          <Radio
            mealName={mealName} 
            day={x} 
            filtersId={filtersId} 
            isChecked={isChecked} 
            setFilters={setFilters}
            anyMeal={anyMeal}
          />
        </span>
      )
    }
    return radios
  }

  const onClubOffestOnlyChange = () => {
    setClubOffersOnly(!clubOffersOnly)
  }

  const onAnyMealChange = () => {
  
    updateList(null, null, {
      anyMeal: !anyMeal,
    })
    const filters = {
      filters: [
        {
          'field': 'membership_validities.meal.name',
          'condition': 'eq',
          'value': null,
        },
        {
          'field': 'membership_validities.day_of_week',
          'condition': 'eq',
          'value': null,
        }
      ]
    }
    if ( !anyMeal ) {
      updateSelection(
        filters,
        'clearAllOfType'
      )
    }
    
    setAnyMeal(!anyMeal)
    if ( anyMeal ) {
      setActiveFilters({
        'Breakfast': {},
        'Lunch': {},
        'Afternoon Tea': {},
        'Dinner': {},
      })
    }
  }

  return (
    <div>
      <div className="c-searchClubOffers__table">
        <div className="c-searchClubOffers__tableColumn c-searchClubOffers__tableColumn--left">
          <div className="c-searchClubOffers__tableColumnHeader d-flex align-items-center">
            <p className="c-searchClubOffers__tableTitle">Any meal period</p>
            <div className="c-search__toggleSwitcherWrapper d-flex">
              <input type="checkbox" id="anyMeal" value={anyMeal} onChange={onAnyMealChange} />
              <label htmlFor="anyMeal" />
            </div>
          </div>
          <div className="c-searchClubOffers__tableCell">
            <span>Breakfast</span>
          </div>
          <div className="c-searchClubOffers__tableCell">
            <span>Lunch</span>
          </div>
          <div className="c-searchClubOffers__tableCell">
            <span>Afternoon Tea</span>
          </div>
          <div className="c-searchClubOffers__tableCell">
            <span>Dinner</span>
          </div>
        </div>
        <div className="c-searchClubOffers__tableColumn c-searchClubOffers__tableColumn--right">
          <div className="c-searchClubOffers__tableColumnHeader">
            <span>M</span>
            <span>T</span>
            <span>W</span>
            <span>T</span>
            <span>F</span>
            <span>S</span>
            <span>S</span>
          </div>

          <div className="c-searchClubOffers__tableCell">
            { getRadios('Breakfast')}
          </div>
          <div className="c-searchClubOffers__tableCell">
            { getRadios('Lunch')}
          </div>
          <div className="c-searchClubOffers__tableCell">
            { getRadios('Afternoon Tea')}
          </div>
          <div className="c-searchClubOffers__tableCell">
            { getRadios('Dinner')}
          </div>

        </div>
      </div>
      <div className="c-searchCheckbox c-searchCheckbox--clubOffersOnly h-checkbox">
        <label className="h-checkbox__label">
          <input className="h-checkbox__input" type="checkbox" checked={clubOffersOnly} onChange={onClubOffestOnlyChange} />
          <div className="h-checkbox__icon" />
          <span className="d-flex align-items-center">Show club offers only</span>
        </label>
      </div>
      
    </div>
  )
}

export default ClubOffers